import { IBarrier } from '@interfaces/task/barrier'
type TMockedBarrier = IBarrier

export const mockedBarriers: TMockedBarrier[] = [
  {
    comments: [
      {
        barrierId: 1003730,
        comment: 'test',
        isSapComment: false,
        user: {
          firstName: 'John',
          lastName: 'Doe',
          email: 'john.doe@test.com',
          uid: 'c8d69d40-e930-498a-ac20-cc0731a72802',
          id: 1000666,
        },
        id: 1004099,
        createdOn: new Date(),
        updatedOn: new Date(),
      },
    ],
    barrierCode: {
      description: 'E.07 - Process equipment unavailable',
      isActive: false,
      id: 212,
    },
    hoursLost: 2,
    wasCausedByPreviousShift: false,
    taskId: 592517,
    barrierCodeId: 212,
    userId: 1000666,
    jobId: 0,
    taskStatus: 0,
    user: {
      firstName: 'John',
      lastName: 'Doe',
      email: 'john.doe@test.com',
      uid: 'c8d69d40-e930-498a-ac20-cc0731a72802',
      id: 1000666,
    },
    id: 1003730,
  },
  {
    comments: [
      {
        barrierId: 1003731,
        comment: 'test 2',
        isSapComment: false,
        user: {
          firstName: 'John',
          lastName: 'Doe',
          email: 'john.doe@test.com',
          uid: 'c8d69d40-e930-498a-ac20-cc0731a72802',
          id: 1000666,
        },
        id: 1004100,
        createdOn: new Date(),
        updatedOn: new Date(),
      },
    ],
    barrierCode: {
      description: 'E.10 - Scope Change/Expansion',
      isActive: false,
      id: 240,
    },
    hoursLost: 3,
    wasCausedByPreviousShift: true,
    taskId: 592517,
    barrierCodeId: 240,
    userId: 1000666,
    jobId: 0,
    taskStatus: 0,
    user: {
      firstName: 'John',
      lastName: 'Doe',
      email: 'john.doe@test.com',
      uid: 'c8d69d40-e930-498a-ac20-cc0731a72802',
      id: 1000666,
    },
    id: 1003731,
  },
]
